import { render, staticRenderFns } from "./PriorIcon.vue?vue&type=template&id=176bda7e&scoped=true&"
import script from "./PriorIcon.vue?vue&type=script&lang=ts&"
export * from "./PriorIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PriorIcon.vue?vue&type=style&index=0&id=176bda7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176bda7e",
  null
  
)

export default component.exports